// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1wCdR","author":"Table_author__1Z6Qa","authorImage":"Table_authorImage__15cDZ","unreadRow":"Table_unreadRow__1vf1o"};